import React from "react"

const VideoModal = ({ videoUrl, onClose, isOpen }) => {
  if (!isOpen || !videoUrl) return null

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/75" onClick={onClose}>
      <div
        className="relative max-h-screen w-full max-w-4xl rounded-lg bg-white p-4 shadow-lg"
        onClick={(e) => e.stopPropagation()}>
        <button
          onClick={onClose}
          className="absolute -right-3 -top-3 flex h-8 w-8 items-center justify-center rounded-full bg-gray-dark text-white transition-colors hover:bg-gray-600">
          <i className="icon-close" />
        </button>
        <video src={videoUrl} controls autoPlay className="w-full rounded" style={{ maxHeight: "90vh" }} />
      </div>
    </div>
  )
}

export default VideoModal
